// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"topic-header_headerContainer__mH0Id","inverted":"topic-header_inverted__CJDLa","imageHeader":"topic-header_imageHeader__TL7Ey"};